/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFolderQuestion = createReactComponent("folder-question", "IconFolderQuestion", [
  [
    "path",
    {
      d: "M15 19h-10a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v2.5",
      key: "svg-0"
    }
  ],
  ["path", { d: "M19 22v.01", key: "svg-1" }],
  [
    "path",
    {
      d: "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483",
      key: "svg-2"
    }
  ]
]);

export { IconFolderQuestion as default };
//# sourceMappingURL=IconFolderQuestion.js.map
